export default __webpack_public_path__ + "static/media/Meiqing.465d0343.png";